<template>
	<div class="section pride-coming-home-container" v-bind:style="{ 'background-image': 'url(' + getImgUrl(comingHome.BG_IMAGE) + ')' }" ref="cominghome">
		<div class="pride-inner">
			<h1 v-html="comingHome.HEADER"></h1>
			<h3 v-html="comingHome.COPY"></h3>
		</div>
	</div>
</template>

<script>


import isIntersectingMixin from '../../mixins/isIntersectingMixin';

export default {
    name: "pride-coming-home",
		mixins: [isIntersectingMixin],
		props: {
			comingHome: {
				type: Object,
				default: () => {
					return {
						root: null,
					};
				}
			}
		},
		// data(){
		// 	return{
		// 		observer : null
		// 	}
		// },
		// mounted(){
		// 	this.observer = new IntersectionObserver(this.onIntersect, {
		// 		root: null,
		// 		rootMargin: '0px 0px 0px 0px',
		// 		threshold: .5,
		// 	})

		// 	this.observer.observe(this.$el)
		// },
		// destroyed(){
		// 	this.observer.disconnect()
		// 	this.observer = null
		// },
		methods: {
			getImgUrl: place => {
				const images = require.context(
					"./../../assets/pride/",
					false
				);
				return  images("./" + place) 
			},

			onIntersect(event) {
				const cominghome = this.$refs.cominghome;
				const isIntersecting = event.find((entry) => {
					return entry.isIntersecting
				})
				if (isIntersecting) {
					this.$emit('intersect', event)
					// console.log("coming home intersecting")
					cominghome.querySelector('h1').classList.add("header_ani");
					cominghome.querySelector('h3').classList.add("copy_ani");
				}
    	},

		}
};

</script>

<style lang='scss' scoped>

	.pride-coming-home-container {

		background-size: cover;
		background-repeat: no-repeat;
		background-position: center;
		@media (min-width: 768px) {
					background-attachment: fixed;
		}
		h1, h3 {
			opacity: 0;
		}


		@media (min-width: 768px) {
			min-height: 615px;
		}

		.pride-inner {
			padding: 4em 1em;
			max-width: 1050px;
		}

		.header_ani {
			animation: move 1s forwards;
			animation-delay: 100ms;
		}

		.copy_ani {
			animation: move 1s forwards;
			animation-delay: 100ms;
		}

		@keyframes move {
			from {
				transform: translateY(100%);
				opacity: 0;
			}

			to {
				transform: translateY(0%);
				opacity: 1;
			}
		}

	}

</style>


// WEBPACK FOOTER //
// src/components/pride/PrideComingHome.vue